import { toast } from "react-toastify";
import api from "../../services/api";
import type { IGetPartnersResponse } from "./types";

export function createPartnersUtils() {
  return {
    async getPartners() {
      try {
        const response = await api.get<IGetPartnersResponse>("/list/partners");
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async approvePartner(id: number, data: any) {
      try {
        const response = await api.post(`/approve/partner/${id}`, data);
        if (response?.data?.message) {
          toast.success(response?.data?.message);
        }
        return response.data;
      } catch (error: any) {
        console.error(error);
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
      }
    },
  };
}
